import { useMutation } from '@apollo/client';
import type { ApiOptions } from '../helpers';
import { isSessionExpired } from './errors';
import { SendRemoteCommandDocument } from './send-command.generated';

type SendRemoteCommandOptions = ApiOptions<typeof SendRemoteCommandDocument> & {
  /** The session ended, so the page can refetch into its expired copy. */
  onSessionExpired?: () => void;
};

/**
 * Raises no snackbar, unlike every other mutation in the app: a fan holding a phone gets these
 * states from the page instead of a red bar over the buttons they are pressing.
 */
export const useSendRemoteCommand = ({
  onSessionExpired,
  ...options
}: SendRemoteCommandOptions = {}) =>
  useMutation(SendRemoteCommandDocument, {
    ...options,
    // Spread last so a caller's own onError adds to the refetch rather than replacing it.
    onError: (error) => {
      if (isSessionExpired(error)) onSessionExpired?.();
      options.onError?.(error);
    },
  });
